import {
  vhmEmptyMsgClasses,
  vhmFileItemClasses,
  vhmFileItemActiveClasses,
  vhmChevronClasses,
} from "./versionHistoryClasses";

const buildFileItemClassName = (isActive) =>
  `${vhmFileItemClasses}${isActive ? ` ${vhmFileItemActiveClasses}` : ""}`;

const LifecareClientList = ({ clients, selectedClientId, onSelect }) => {
  if (!clients.length) return <div className={vhmEmptyMsgClasses}>No clients available</div>;
  return clients.map((c) => (
    <div
      key={c.clientId}
      className={buildFileItemClassName(selectedClientId === c.clientId)}
      onClick={() => onSelect(c.clientId)}
    >
      {c.clientName}
      <i className={`fa fa-chevron-right ${vhmChevronClasses}`} aria-hidden="true" />
    </div>
  ));
};

export default LifecareClientList;
